function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  id: "7it5ns1lia",
  d: "M8.98 0c4.959 0 8.98 4.02 8.98 8.98 0 2.307-.871 4.411-2.301 6.002l3.863 3.864c.637.637.637 1.67 0 2.308-.604.604-1.564.636-2.205.096l-.104-.096-4.167-4.166c-1.221.621-2.603.971-4.066.971C4.02 17.96 0 13.94 0 8.98 0 4.02 4.02 0 8.98 0zm0 2.98c-3.314 0-6 2.686-6 6 0 3.313 2.686 6 6 6 3.313 0 6-2.687 6-6 0-3.314-2.687-6-6-6z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1207 -1752) translate(1207.103 1752) translate(2 1)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#202124",
  fillRule: "nonzero",
  xlinkHref: "#7it5ns1lia"
})))));

var SvgIconSearchBlack = function SvgIconSearchBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSearchBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-search-black.8c3c0e81.svg";
export { ForwardRef as ReactComponent };